<template>
  <div>
    <el-dialog title="ログイン" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form">
        <el-form-item label="ID" :label-width="formLabelWidth">
          <el-input v-model="form.input_id" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="PASS" :label-width="formLabelWidth">
          <el-input v-model="form.input_pass" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="login">ログイン</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import sha256 from 'js-sha256'
const BASICID = process.env.BASIC_ID
const BASICPASS = process.env.BASIC_PASS
const DIGESTKEY = process.env.DIGEST_KEY

export default {
  name: 'Login',
  data () {
    return {
      dialogFormVisible: true,
      allert: false,
      form: {
        input_id: '',
        input_pass: ''
      },
      formLabelWidth: '120px'
    }
  },
  methods: {
    login () {
      if ((this.form.input_id !== BASICID || this.form.input_pass !== BASICPASS)) {
        this.$notify.error({
          title: 'Error',
          message: 'ID,またはパスワードが違います'})
      } else {
        // SHA256形式でID,PASSを暗号化してcookieに保存
        const inputId = sha256.hmac(DIGESTKEY, this.form.input_id)
        const inputPass = sha256.hmac(DIGESTKEY, this.form.input_pass)
        this.$cookie.set('input_id', inputId, { expires: '1h' })
        this.$cookie.set('input_pass', inputPass, { expires: '1h' })
        window.location.href = '/'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/basic/Login.vue